var ButtonName = /* @__PURE__ */ ((ButtonName2) => {
  ButtonName2["AddToBagButton"] = "addToBagButton";
  ButtonName2["BagDrawerCheckoutButton"] = "bagDrawerCheckoutButton";
  ButtonName2["BagDrawerViewBagButton"] = "bagDrawerViewBagButton";
  ButtonName2["BagButton"] = "bagButton";
  ButtonName2["EmptyBagMessageCardButton"] = "emptyBagMessageCardButton";
  ButtonName2["ShareDialogButton"] = "shareDialogButton";
  ButtonName2["CheckoutQuantityControl"] = "checkoutQuantityControl";
  ButtonName2["MembershipButton"] = "membershipButton";
  ButtonName2["ProfileButton"] = "profileButton";
  ButtonName2["LocationMapSearchButton"] = "locationMapSearchButton";
  ButtonName2["LocationMapSearchResultsButton"] = "locationMapSearchResultsButton";
  ButtonName2["AddToBagModalButton"] = "addToBagModalButton";
  return ButtonName2;
})(ButtonName || {});
var DTCComponentName = /* @__PURE__ */ ((DTCComponentName2) => {
  DTCComponentName2["EmptyBagMessageCard"] = "emptyBagMessageCard";
  return DTCComponentName2;
})(DTCComponentName || {});
export {
  ButtonName,
  DTCComponentName
};
//# sourceMappingURL=componentNames.js.map
